class ProductBadge extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("product-badge:update", (e) =>
      this.update(e.detail.product)
    );
  }

  update(product) {
    let style = "hidden";
    let content = "";

    const compareAtPrice = parseFloat(product.helpers.compareAtPrice);
    const price = parseFloat(product.helpers.price);

    if (compareAtPrice !== 0 && compareAtPrice > price) {
      style = "sale";
      content = window.priceStrings.sale;
    }

    if (product.badgeNew?.value === "true") {
      style = "new";
      content = window.priceStrings.new;
    }

    if (product.badgeCustom?.value) {
      style = "custom";
      content = product.badgeCustom.value.replace(/\n/g, "<br>");
    }

    this.setAttribute("badge-style", style);
    this.innerHTML = content;
  }
}

if (!customElements.get("product-badge")) {
  customElements.define("product-badge", ProductBadge);
}
